import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

export const CustomerTerminationReasons = [
  WintSuperkollAPIModel.EmploymentTerminationReason.VoluntaryResignation,
  WintSuperkollAPIModel.EmploymentTerminationReason.Redundancy,
  WintSuperkollAPIModel.EmploymentTerminationReason.Death,
  WintSuperkollAPIModel.EmploymentTerminationReason.ChangeOfEmploymentForm,
];

export const terminationReasonLabel = (value: WintSuperkollAPIModel.EmploymentTerminationReason): string =>
  CustomerTerminationReasons.includes(value)
    ? LocalizationHelperInstance.getTranslatedEnumValue(TranslationKeys.Settings.TerminationReason, value)
    : WintSuperkollAPIModel.EmploymentTerminationReason[value];
